import MeshCoverageLayer from '../layers/MeshCoverageLayer';
import { meshCoverageRuntime } from './mesh-coverage-runtime';
import OrthoLayer from '../layers/OrthoLayer';
import GesutLayer from '../layers/GesutLayer';
import PortPolskaLayer from '../layers/PortPolskaLayer';
import SidusisLayer from '../layers/SidusisLayer';
import MpzpLayer from '../layers/MpzpLayer';
import MpzpImportedLayer from '../layers/MpzpImportedLayer';
import PogLayer from '../layers/PogLayer';
import StudiumLayer from '../layers/StudiumLayer';
import PowodzLayer from '../layers/PowodzLayer';
import KowrLayer from '../layers/KowrLayer';
import EducationFacilitiesLayer from '../layers/EducationFacilitiesLayer';
import OwnershipLayer from '../layers/OwnershipLayer';
import LandUseLayer from '../layers/LandUseLayer';
import NoiseContourLayer from '../layers/NoiseContourLayer';
import NoiseMonitoringLayer from '../layers/NoiseMonitoringLayer';
import { kowrLayerRuntime } from './kowr-layer-runtime';
import { educationLayerRuntime } from './education-layer-runtime';
import { ownershipLayerRuntime } from './ownership-layer-runtime';
import { landUseLayerRuntime } from './land-use-layer-runtime';
import { noiseLayerRuntime } from './noise-layer-runtime';
import TransactionsLayer from '../layers/TransactionsLayer';
import SignalsLayer from '../layers/SignalsLayer';
import ListingsLayer from '../layers/ListingsLayer';
import DeveloperOffersLayer from '../layers/DeveloperOffersLayer';
import DzialkiLayer from '../layers/DzialkiLayer';
import DzialkiVectorTileLayer from '../layers/DzialkiVectorTileLayer';
import BudynkiLayer from '../layers/BudynkiLayer';
import GunbLayer from '../layers/GunbLayer';
import OtoczenieLayer from '../layers/OtoczenieLayer';
import SelectionPinLayer from '../layers/SelectionPinLayer';

function createBaseLayerOptions(config, layerKey, state) {
    return {
        getMap: config.getMap,
        getLayer: state.getLayer,
        setLayer: state.setLayer,
        getToggleEl: function() { return config.getLayerToggleEl(layerKey); },
        getActive: state.getActive,
        setActive: state.setActive,
        getDesired: state.getDesired,
        setDesired: state.setDesired,
        onRequestStarted: config.onDataLayerRequestStarted,
        onRequestSettled: config.onDataLayerRequestSettled,
    };
}

function createKowrController(config) {
    var controller = new KowrLayer({
        baseUrl: config.baseUrl,
        getMap: config.getMap,
        getLayer: kowrLayerRuntime.getLayer,
        setLayer: kowrLayerRuntime.setLayer,
        getToggleEl: function() { return config.getLayerToggleEl('kowr'); },
        getActive: kowrLayerRuntime.getActive,
        setActive: kowrLayerRuntime.setActive,
        getDesired: kowrLayerRuntime.getDesired,
        setDesired: kowrLayerRuntime.setDesired,
        onRequestStarted: config.onDataLayerRequestStarted,
        onRequestSettled: config.onDataLayerRequestSettled,
        onLoaded: config.onBringDataLayersToFront,
        onStateChange: config.onStateChange,
    });
    kowrLayerRuntime.setController(controller);
    return controller;
}

function createEducationController(config) {
    var controller = new EducationFacilitiesLayer({
        accumulate: true,
        baseUrl: config.baseUrl,
        getMap: config.getMap,
        getLayer: educationLayerRuntime.getLayer,
        setLayer: educationLayerRuntime.setLayer,
        getToggleEl: function() { return config.getLayerToggleEl('education'); },
        getActive: educationLayerRuntime.getActive,
        setActive: educationLayerRuntime.setActive,
        getDesired: educationLayerRuntime.getDesired,
        setDesired: educationLayerRuntime.setDesired,
        getAbortController: educationLayerRuntime.getAbortController,
        setAbortController: educationLayerRuntime.setAbortController,
        getCurrentBbox: config.getCurrentBbox,
        onRequestStarted: config.onDataLayerRequestStarted,
        onRequestSettled: config.onDataLayerRequestSettled,
        onRendered: function() {
            if (config.onBringDataLayersToFront) config.onBringDataLayersToFront();
        },
        onStateChange: config.onStateChange,
    });
    educationLayerRuntime.setController(controller);
    return controller;
}

function createOwnershipController(config, getParcelController) {
    var controller = new OwnershipLayer({
        baseUrl: config.baseUrl,
        getMap: config.getMap,
        getParcelController: getParcelController,
        getLayer: ownershipLayerRuntime.getLayer,
        setLayer: ownershipLayerRuntime.setLayer,
        getToggleEl: function() { return config.getLayerToggleEl('ownership'); },
        getActive: ownershipLayerRuntime.getActive,
        setActive: ownershipLayerRuntime.setActive,
        getDesired: ownershipLayerRuntime.getDesired,
        setDesired: ownershipLayerRuntime.setDesired,
        onLoaded: config.onBringDataLayersToFront,
        onStateChange: config.onStateChange,
    });
    ownershipLayerRuntime.setController(controller);
    return controller;
}

function createLandUseController(config, getParcelController) {
    var controller = new LandUseLayer({
        baseUrl: config.baseUrl,
        getMap: config.getMap,
        getParcelController: getParcelController,
        getLayer: landUseLayerRuntime.getLayer,
        setLayer: landUseLayerRuntime.setLayer,
        getToggleEl: function() { return config.getLayerToggleEl('landUse'); },
        getActive: landUseLayerRuntime.getActive,
        setActive: landUseLayerRuntime.setActive,
        getDesired: landUseLayerRuntime.getDesired,
        setDesired: landUseLayerRuntime.setDesired,
        onLoaded: config.onBringDataLayersToFront,
        onStateChange: config.onStateChange,
    });
    landUseLayerRuntime.setController(controller);
    return controller;
}

function createNoiseController(config, key, indicator) {
    var abortController = null;
    var ControllerClass = key === 'noiseMonitoring' ? NoiseMonitoringLayer : NoiseContourLayer;
    var controller = new ControllerClass({
        id: key,
        indicator: indicator,
        baseUrl: config.baseUrl,
        getMap: config.getMap,
        getToggleEl: function() {
            if (typeof document === 'undefined') return null;
            return document.querySelector('[data-noise-layer="' + key + '"]');
        },
        getActive: function() { return noiseLayerRuntime.getActive(key); },
        setActive: function(value) { noiseLayerRuntime.setActive(key, value); },
        getDesired: function() { return noiseLayerRuntime.getDesired(key); },
        setDesired: function(value) { noiseLayerRuntime.setDesired(key, value); },
        getAbortController: function() { return abortController; },
        setAbortController: function(value) { abortController = value; },
        getCurrentBbox: config.getCurrentBbox,
        getCurrentZoom: config.getMapZoom,
        onRequestStarted: config.onDataLayerRequestStarted,
        onRequestSettled: config.onDataLayerRequestSettled,
        onMapClickHandled: config.onMapClickHandled,
        onMetadata: function(value) { noiseLayerRuntime.updateMetadata(key, value); },
        onRendered: function(data, layer, renderedController) {
            if (config.onRenderNoise) config.onRenderNoise(key, data, layer, renderedController);
        },
        onStateChange: function() { noiseLayerRuntime.syncAll(); },
    });
    noiseLayerRuntime.registerController(key, controller);
    return controller;
}

export function createLayerControllers(config) {
    var layers = config.layers;
    const meshController = new MeshCoverageLayer({
        baseUrl: config.baseUrl, getMap: config.getMap,
        getToggleEl: () => config.getLayerToggleEl('widoki3d'),
        getActive: meshCoverageRuntime.getActive, setActive: meshCoverageRuntime.setActive,
        getDesired: meshCoverageRuntime.getDesired, setDesired: meshCoverageRuntime.setDesired,
        onStateChange: config.onStateChange,
    });
    meshCoverageRuntime.setController(meshController);
    var DzialkiControllerClass = config.parcelRenderMode === 'vector'
        ? DzialkiVectorTileLayer
        : DzialkiLayer;
    var ownershipController = null;
    var landUseController = null;
    var dzialkiController = new DzialkiControllerClass(Object.assign(
        createBaseLayerOptions(config, 'dzialki', layers.dzialki),
        {
            accumulate: config.parcelRenderMode !== 'vector',
            baseUrl: config.baseUrl,
            getAbortController: layers.dzialki.getAbortController,
            setAbortController: layers.dzialki.setAbortController,
            getCurrentBbox: config.getCurrentBbox,
            getCurrentZoom: config.getMapZoom,
            onLoaded: function() {
                if (config.onBringDataLayersToFront) config.onBringDataLayersToFront();
                if (ownershipController) ownershipController.syncSharedSource();
                if (landUseController) landUseController.syncSharedSource();
            },
            onRendered: function(data, layer, renderedController) {
                if (config.onRenderDzialki) config.onRenderDzialki(data, layer, renderedController);
                if (ownershipController) ownershipController.syncSharedSource();
                if (landUseController) landUseController.syncSharedSource();
            },
            onCleared: function() {
                if (ownershipController && ownershipController.isActive()) ownershipController.load();
                if (landUseController && landUseController.isActive()) landUseController.load();
            },
            onStateChange: config.onStateChange,
        }
    ));
    ownershipController = createOwnershipController(config, function() { return dzialkiController; });
    landUseController = createLandUseController(config, function() { return dzialkiController; });

    return {
        orthoController: new OrthoLayer(Object.assign(
            createBaseLayerOptions(config, 'ortho', layers.ortho),
            { onStateChange: config.onStateChange }
        )),

        gesutController: new GesutLayer(Object.assign(
            createBaseLayerOptions(config, 'gesut', layers.gesut),
            {
                onLoaded: config.onBringDataLayersToFront,
                onStateChange: config.onStateChange,
            }
        )),

        portPolskaController: new PortPolskaLayer(Object.assign(
            createBaseLayerOptions(config, 'portPolska', layers.portPolska),
            {
                onLoaded: config.onBringDataLayersToFront,
                onStateChange: config.onStateChange,
                baseUrl: config.baseUrl,
            }
        )),

        sidusisController: new SidusisLayer(Object.assign(
            createBaseLayerOptions(config, 'sidusis', layers.sidusis),
            {
                onLoaded: config.onBringDataLayersToFront,
                onStateChange: config.onStateChange,
                onAttributionChange: function(credit) { config.onOverlayAttributionChange('sidusis', credit); },
            }
        )),

        mpzpController: new MpzpLayer(Object.assign(
            createBaseLayerOptions(config, 'mpzp', layers.mpzp),
            {
                onLoaded: config.onBringDataLayersToFront,
                onStateChange: config.onStateChange,
            }
        )),

        mpzpRuController: new MpzpImportedLayer(Object.assign(
            createBaseLayerOptions(config, 'mpzpRu', layers.mpzpRu),
            {
                baseUrl: config.baseUrl,
                getCurrentBbox: config.getCurrentBbox,
                getCurrentZoom: config.getMapZoom,
                getAbortController: layers.mpzpRu.getAbortController,
                setAbortController: layers.mpzpRu.setAbortController,
                onRendered: config.onRenderMpzpRu,
                onLoaded: config.onBringDataLayersToFront,
                onStateChange: config.onStateChange,
            }
        )),

        pogController: new PogLayer(Object.assign(
            createBaseLayerOptions(config, 'pog', layers.pog),
            {
                onLoaded: config.onBringDataLayersToFront,
                onStateChange: config.onStateChange,
            }
        )),

        studiumController: new StudiumLayer(Object.assign(
            createBaseLayerOptions(config, 'studium', layers.studium),
            {
                onLoaded: config.onBringDataLayersToFront,
                onStateChange: config.onStateChange,
            }
        )),

        powodzController: new PowodzLayer(Object.assign(
            createBaseLayerOptions(config, 'powodz', layers.powodz),
            {
                onLoaded: config.onBringDataLayersToFront,
                onStateChange: config.onStateChange,
            }
        )),

        kowrController: createKowrController(config),
        educationController: createEducationController(config),
        ownershipController: ownershipController,
        landUseController: landUseController,
        noiseLdwnController: createNoiseController(config, 'noiseLdwn', 'LDWN'),
        noiseLnController: createNoiseController(config, 'noiseLn', 'LN'),
        noiseMonitoringController: createNoiseController(config, 'noiseMonitoring', null),

        transactionsController: new TransactionsLayer(Object.assign(
            createBaseLayerOptions(config, 'transakcje', layers.transakcje),
            {
                accumulate: true,
                getAbortController: layers.transakcje.getAbortController,
                setAbortController: layers.transakcje.setAbortController,
                getGeoQuery: config.getGeoQuery,
                isLimitedMode: config.isLimitedMode,
                individualZoomThreshold: config.individualZoomThreshold,
                formatAggCount: config.formatAggCount,
                onMapClickHandled: config.onMapClickHandled,
                onFeatureSelect: config.onSelectTransaction,
                onRendered: config.onRenderGeoJson,
                onLoadingChange: config.onLoadingChange,
                onCleared: config.onLimitedModeCleared,
                onLimitedMode: config.onLimitedModeCleared,
                onFetchError: config.onFetchGeoJsonError,
                getClusterViewportPadding: config.getClusterViewportPadding,
            }
        )),

        signalsController: new SignalsLayer(Object.assign(
            createBaseLayerOptions(config, 'sygnaly', layers.sygnaly),
            {
                accumulate: true,
                baseUrl: config.baseUrl,
                getAbortController: layers.sygnaly.getAbortController,
                setAbortController: layers.sygnaly.setAbortController,
                getCurrentBbox: config.getCurrentBbox,
                getCurrentZoom: config.getMapZoom,
                onRendered: config.onRenderSignals,
                onCleared: config.onSignalsCleared,
                onStateChange: config.onStateChange,
                selectSignalHit: config.onSelectSignalHit,
            }
        )),

        listingsController: new ListingsLayer(Object.assign(
            createBaseLayerOptions(config, 'ogloszenia', layers.ogloszenia),
            {
                accumulate: true,
                baseUrl: config.baseUrl,
                getAbortController: layers.ogloszenia.getAbortController,
                setAbortController: layers.ogloszenia.setAbortController,
                getCurrentBbox: config.getCurrentBbox,
                getCurrentZoom: config.getMapZoom,
                getListingFilterParams: config.getListingFilterParams,
                getListingRadiusFilterState: config.getListingRadiusFilterState,
                onRendered: config.onRenderListings,
                onCleared: config.onListingsCleared,
                onSelectListing: config.onSelectListing,
                onClusterClick: config.onListingClusterClick,
                onStateChange: config.onStateChange,
            }
        )),

        developerOffersController: new DeveloperOffersLayer(Object.assign(
            createBaseLayerOptions(config, 'ofertyDeweloperow', layers.ofertyDeweloperow),
            {
                accumulate: true,
                baseUrl: config.baseUrl,
                getAbortController: layers.ofertyDeweloperow.getAbortController,
                setAbortController: layers.ofertyDeweloperow.setAbortController,
                getCurrentBbox: config.getCurrentBbox,
                getCurrentZoom: config.getMapZoom,
                getDeveloperOfferFilterParams: config.getDeveloperOfferFilterParams,
                onRendered: config.onRenderDeveloperOffers,
                onCleared: config.onDeveloperOffersCleared,
                onSelectDeveloperInvestment: config.onSelectDeveloperInvestment,
                onStateChange: config.onStateChange,
            }
        )),

        dzialkiController: dzialkiController,

        budynkiController: new BudynkiLayer(Object.assign(
            createBaseLayerOptions(config, 'budynki', layers.budynki),
            {
                accumulate: true,
                getAbortController: layers.budynki.getAbortController,
                setAbortController: layers.budynki.setAbortController,
                getCurrentBbox: config.getCurrentBbox,
                getCurrentZoom: config.getMapZoom,
                isInteractive: config.isDesktopLayout,
                onMapClickHandled: config.onMapClickHandled,
                onFeatureSelect: config.onSelectBuilding,
                onRendered: config.onRenderBudynki,
                onStateChange: config.onStateChange,
            }
        )),

        gunbController: new GunbLayer(Object.assign(
            createBaseLayerOptions(config, 'gunb', layers.gunb),
            {
                accumulate: true,
                baseUrl: config.baseUrl,
                getAbortController: layers.gunb.getAbortController,
                setAbortController: layers.gunb.setAbortController,
                getCurrentBbox: config.getCurrentBbox,
                getCurrentZoom: config.getMapZoom,
                getFilterQueryString: config.getGunbFilterQueryString,
                isInteractive: config.isDesktopLayout,
                onMapClickHandled: config.onMapClickHandled,
                onSelectPermit: config.onSelectGunbPermit,
                onBrowseGroup: config.onBrowseGunbGroup,
                onGroupsChange: config.onGunbGroupsChange,
                onRendered: config.onRenderGunb,
                onCleared: config.onGunbCleared,
                onStateChange: config.onStateChange,
            }
        )),

        otoczenieController: new OtoczenieLayer(Object.assign(
            createBaseLayerOptions(config, 'otoczenie', layers.otoczenie),
            {
                baseUrl: config.baseUrl,
                getAbortController: layers.otoczenie.getAbortController,
                setAbortController: layers.otoczenie.setAbortController,
                getCurrentBbox: config.getCurrentBbox,
                getCurrentZoom: config.getMapZoom,
                getFilterQueryString: config.getBdot10kFilterQueryString,
                renderData: config.onRenderOtoczenie,
                onStateChange: config.onStateChange,
            }
        )),

        selectionPinController: new SelectionPinLayer({
            overlayLayersMinZoom: config.overlayLayersMinZoom,
            getMap: config.getMap,
            getLayer: layers.selectionPin.getLayer,
            setLayer: layers.selectionPin.setLayer,
            getAbortController: layers.selectionPin.getAbortController,
            setAbortController: layers.selectionPin.setAbortController,
            getActiveTab: config.getActiveTab,
            getSelectedDid: config.getSelectedDid,
            getSelectedBid: config.getSelectedBid,
            onRendered: config.onRenderSelectionPin,
        }),
    };
}
